"use client";

import { useEffect } from "react";
import { useAuthStore, subscribeAuthBroadcast } from "@/store/auth.store";

export function AuthBootstrapper() {
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    void initialize();
  }, [initialize]);

  // Cross-tab auth sync: başka sekmede login/logout olunduğunda bu sekmeyi güncelle
  useEffect(() => {
    const unsubscribe = subscribeAuthBroadcast((action) => {
      if (action === "logout") {
        window.location.reload();
      } else if (action === "login") {
        window.location.reload();
      }
    });
    return unsubscribe;
  }, []);

  // Sekme odaklandığında auth durumunu kontrol et (session cookie hâlâ geçerli mi)
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        void initialize();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, [initialize]);

  return null;
}
